export default new Map([
  ['ACH', `Your transfer is processing.<br>Keep in mind, transfers <strong>from or to</strong> another
    institution take up to 3 business days to process. If you\'d like to cancel your transfer before it
    goes through, you can go online to Invest Transfer Activity or call us at 1-855-880-2559.`],
  ['ACH_AFTER_255', `Business Day Cutoff (Outside Institution/ACH).<br>Your request was submitted after
    2:55 pm ET, so we\'ll process it the next business day. If you\'d like to cancel your transfer before
    it goes through, you can go online to Invest Transfer Activity or call us at 1-855-880-2559.`],
  ['OAT_AFTER_355', `The cutoff for transfers to or from Ally Bank is 3:55 pm ET on non-holidays and 12:55
    pm ET on market half-days. Select the next available business day to continue with your transfer.`],
  ['OAT_NONRECURRING', `You\'ll get an email confirmation and see it updated in your Transfers Activity
    once it\'s complete.`],
  ['OAT_RECURRING', `Your recurring transfer request is processing.<br>If you\'d like to cancel your
    recurring transfer at any time, you can go online to Invest Transfer Activity or call us at 1-855-880-2559.`]
]);
